












import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class MassImportBody extends Vue {

  @Prop({default: () => {}}) initStepsHandler: () => void;

}
